import styled from "styled-components";
import {
  COLORS,
  FlashPCBTable,
  FONT_SIZE,
  FONT_WEIGHT,
} from "../../../constants/Styles";

export const FilesTable = styled(FlashPCBTable)`
  border-collapse: collapse;
`;

// Rows are shaded per file group rather than per row, so previous versions
// read as part of the file above them.
export const FileRow = styled.tr<{ $shaded: boolean; $previous: boolean }>`
  background: ${({ $shaded }) => {
    return $shaded ? COLORS.inputGray : COLORS.tableBackground;
  }};
  color: ${({ $previous }) => {
    return $previous ? COLORS.secondaryLight : COLORS.secondary;
  }};
  font-size: ${({ $previous }) => {
    return $previous ? FONT_SIZE.size12 : FONT_SIZE.size14;
  }};
`;

export const FileCell = styled.td`
  padding: 0.375rem 0.5rem;
  vertical-align: middle;
`;

export const PanelDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1rem;
`;

export const BoardNotes = styled.div`
  display: flex;
  flex-direction: column;
`;
export const GridTable = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.75rem;
`;

export const GridCard = styled.div<{
  highlight: boolean;
}>`
  padding: 0.75rem;
  border-radius: 6px;

  background-color: ${({ highlight }) => {
    return highlight ? "#8b1e1e" : "#fafafa";
  }};
  border: 1px solid
    ${({ highlight }) => {
      return highlight ? "#8b0000" : "#e5e5e5";
    }};
`;

export const CardLabel = styled.div<{ highlight: boolean }>`
  font-size: 0.8rem;
  color: ${({ highlight }) => {
    return highlight ? "#fafafa" : "#666";
  }};
  margin-bottom: 0.25rem;
`;

export const CardValue = styled.div<{ highlight: boolean }>`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.95rem;
  font-weight: ${({ highlight }) => {
    return highlight ? 600 : 400;
  }};
  color: ${({ highlight }) => {
    return highlight ? "#fafafa" : "#111";
  }};
`;

export const TitleWarning = styled.div`
  display: flex;
  align-items: center;
`;

export const PartOrContainerTypeWarning = styled.li`
  font-weight: ${FONT_WEIGHT.weight700};
`;

export const PartWarningsList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: center;
`;

export const StencilDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
`;

export const ExpandToggle = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0;
  border: none;
  background: transparent;
  color: ${COLORS.secondaryLight};
  font-size: ${FONT_SIZE.size12};
  cursor: pointer;

  &:hover {
    color: ${COLORS.secondary};
  }
`;

export const Chevron = styled.span<{ $expanded: boolean }>`
  width: 0.375rem;
  height: 0.375rem;
  border-right: 1.5px solid currentColor;
  border-bottom: 1.5px solid currentColor;
  transform: ${({ $expanded }) => {
    return $expanded ? "translateY(-2px) rotate(45deg)" : "rotate(-45deg)";
  }};
  transition: transform 0.15s ease;
`;
